export const typeMarketData = [
  {
    codigo_mercado: 'MKTTP_REG',
    nombre_mercado: 'MERCADO PRIMARIO',
  },
  {
    codigo_mercado: 'MKTTP_REG',
    nombre_mercado: 'MERCADO SECUNDARIO',
  },
];
